import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render((
	<Router>
		<App />
	</Router>
)
	, document.getElementById('root'));
// do not uncomment - problem in direct downloads!
// eslint-disable-next-line max-len
// https://serverfault.com/questions/1026197/nginx-content-disposition-attachment-not-working-on-subdomain?noredirect=1#comment1333606_1026197
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js